var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { axiosPrivate } from "../../../../../api/axios";
import { LogLevel } from "../../../../../Shared/hooks/useLogging/Logging-types";
import { PaymentMethodType } from "../../types/PaymentProcessorTypes";
export const getPaymentMethods = (setLoading, setError, setCustomerCreditCards, setPrimaryCreditCard, setCustomerGiftCards, setEnableGiftCards, datadogLog) => () => __awaiter(void 0, void 0, void 0, function* () {
    setLoading(true);
    yield axiosPrivate
        .get(`/GetPaymentMethods?type=${PaymentMethodType.CARD}&type=${PaymentMethodType.GIFTCARD}`)
        .then(({ data }) => {
        var _a, _b, _c, _d;
        if (data.success === false) {
            const errorMessage = (_a = data.message) !== null && _a !== void 0 ? _a : "Failed to load payment methods.";
            datadogLog(errorMessage, LogLevel.ERROR);
            setError("Failed to load payment methods.");
        }
        setCustomerCreditCards((_b = data.paymentMethods) === null || _b === void 0 ? void 0 : _b.sort((a, b) => Number(b.isPrimary) - Number(a.isPrimary)));
        setPrimaryCreditCard((_c = data === null || data === void 0 ? void 0 : data.paymentMethods) === null || _c === void 0 ? void 0 : _c.find((pm) => pm.isPrimary));
        setCustomerGiftCards((_d = data.giftCards) === null || _d === void 0 ? void 0 : _d.filter((gc) => gc.giftCard.balance > 0).map((gc) => {
            return {
                id: gc.id,
                type: gc.type,
                giftCardNumber: gc.giftCard.giftCardNumber,
                balance: gc.giftCard.balance,
                initialValue: gc.giftCard.initialValue,
            };
        }));
        setEnableGiftCards(data.enableGiftCards);
    })
        .catch((err) => {
        var _a;
        console.error(err);
        const errorMessage = (_a = err.message) !== null && _a !== void 0 ? _a : "Failed to load billing details.";
        datadogLog(errorMessage, LogLevel.ERROR, {}, err);
        setError("Failed to load billing details.");
    });
    setLoading(false);
});
export const getGiftCardByNumber = (datadogLog) => (giftCardNumber) => __awaiter(void 0, void 0, void 0, function* () {
    return yield axiosPrivate
        .get(`/GetPaymentMethods?type=${PaymentMethodType.GIFTCARD}&giftCardNumber=${giftCardNumber}`)
        .then(({ data }) => {
        if (data.success === false) {
            datadogLog(`Failed to load gift card: ${giftCardNumber}`, LogLevel.ERROR, {});
            return;
        }
        if (!data.giftCards || data.giftCards.length == 0)
            return undefined;
        return {
            id: data.giftCards[0].id,
            type: data.giftCards[0].type,
            giftCardNumber: data.giftCards[0].giftCard.giftCardNumber,
            balance: data.giftCards[0].giftCard.balance,
            initialValue: data.giftCards[0].giftCard.initialValue,
        };
    })
        .catch((err) => {
        var _a;
        console.error(err);
        const errorMessage = (_a = err.message) !== null && _a !== void 0 ? _a : `Failed to load gift card: ${giftCardNumber}`;
        datadogLog(errorMessage, LogLevel.ERROR, {}, err);
        return;
    });
});
